export type PendingSymbolIndexTask = {
  parentPath: string;
  filePath: string;
  priority: number;
  sequence?: number;
};

export function symbolIndexTaskKey(parentPath: string, filePath: string): string {
  return `${parentPath}\0${filePath}`;
}
